export default defineNuxtRouteMiddleware(async (from, to) => {
  if (import.meta.client) {  
    const { $i18n } = useNuxtApp();
    window.___gcfg = {
      lang: $i18n.locale.value,
    };
  }
});
